import { PageHeader } from "@shared/components/PageHeader";
import { ArrowLeft } from "lucide-react";
import { useNavigate, useParams } from "react-router-dom";
import ScheduleDetails from "./details";
import ScheduleQuickActionCard from "./quickActionCard";
import ScheduleRunHistory from "./runHistory/runHistory";
import { Card } from "@shared/ui/card";
import { useGetMeterScheduleDetails } from "@features/mx/readCycleManagement/hooks";

const ScheduleDetailsLanding = () => {
  const navigate = useNavigate();
  const { schedule_id } = useParams();

  const { data: scheduleDetails } = useGetMeterScheduleDetails(schedule_id);

  return (
    <div>
      <div className="space-y-6">
        <div className="flex items-center gap-4">
          {/* Back Arrow */}
          <ArrowLeft
            className="w-5 h-5 cursor-pointer text-gray-700"
            onClick={() => navigate("/mx/read-cycle/?tab=schedules")}
          />

          {/* Page Header */}
          <div className="flex flex-col">
            <PageHeader title="View Schedule" subtitle="Track performance and progress of your Schedule" />
          </div>
        </div>
        <div className="space-y-6">
          <div className="grid grid-cols-12 lg:grid-cols-12 gap-6">
            <div className="lg:col-span-8 space-y-6">
              <ScheduleDetails scheduleDetails={scheduleDetails} />
            </div>
            <div className="lg:col-span-4 space-y-4">
              <ScheduleQuickActionCard scheduleDetails={scheduleDetails} />
            </div>
          </div>
        </div>
        <div className="mt-6 rounded-md border border-blue-200 bg-blue-50 text-blue-800 px-4 py-3 text-md">
          Every run represents a single execution of meter reading under this
          read cycle. Review run history to monitor performance, investigate
          issues, and trigger retries if needed.
        </div>
        <Card className="mt-6">
          <ScheduleRunHistory />
        </Card>
      </div>
    </div>
  );
};

export default ScheduleDetailsLanding;
